import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import type React from 'react';
type ListProps = {
  title: string;
  IconComponent: Icon;
  children: React.ReactNode;
};
const List = t0 => {
  const $ = _c(12);
  const {
    title,
    IconComponent,
    children
  } = t0;
  let t1;
  if ($[0] !== IconComponent) {
    t1 = <IconComponent />;
    $[0] = IconComponent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <h3 className="text-label-2">{title}</h3>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex items-center gap-2 px-3 py-4">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children) {
    t4 = <div className="px-4 pb-3">{children}</div>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex-1 border border-solid rounded border-tertiary">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default List;